// Auth navigators (PRD §9.4 + frontend_architecture.md §6).
//
// Single seam for full-page auth-boundary navigations. Lives in its own
// module so tests can `vi.mock` it without fighting jsdom's locked-down
// `location.assign` setter. Both helpers perform a hard navigation on
// purpose: auth boundaries (logout, login success, dead refresh cookie)
// are the cleanest moments to drop in-memory state and re-bootstrap.

export function redirectToLogin(target: string): void {
  if (typeof window === 'undefined') return;
  window.location.assign(target);
}

/**
 * Post-login navigation. Hard nav (not router push) so the bootstrap
 * refresh + /me fetch run cleanly under a fresh app load — the user's
 * cached state from the anonymous render is dropped, and `redirect`
 * targets that aren't yet registered as TanStack routes still work.
 */
export function redirectAfterLogin(target: string): void {
  if (typeof window === 'undefined') return;
  window.location.assign(target);
}
